import { Button, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import LockIconOpen from '@/assets/icons/ic-lock-open.svg';
import LockIcon from '@/assets/icons/ic-lock.svg';

import { LectureIncludes } from '@/components/ui/shared/lecture/FlippingLectureCardOmnisearch/components/LectureIncludes';
import { LectureKeywords } from '@/components/ui/shared/lecture/FlippingLectureCardOmnisearch/components/LectureKeywords';
import { GeneralMarkdown } from '@/components/ui/shared/markdowns/GeneralMarkdown/GeneralMarkdown';
import { queryThinEvent } from '@/queries/thin-events';
import { OmnisearchThinLecture } from '@/resources/OmnisearchThinLecture';

export const FlippedLectureCard: FC<{ lecture: OmnisearchThinLecture }> = ({ lecture }) => {
  const { t } = useTranslation();
  const { data: event } = useResource(queryThinEvent(lecture.eventId));

  return (
    <Flex backgroundColor="white" p="4" color="black" h="full" w="full" justifyContent="space-between" flexDir="column">
      <Flex flexDir="column">
        <Flex justifyContent="space-between">
          <Text fontSize="sm" fontWeight="bold" noOfLines={1}>
            {event?.name}
          </Text>
          <Icon
            as={lecture.accessRestricted ? LockIcon : LockIconOpen}
            h={6}
            w={6}
            color={lecture.accessRestricted ? 'gray.500' : 'teal.500'}
          />
        </Flex>
        <Heading noOfLines={3} mb="3" fontSize="md" fontWeight="bold" mt={2}>
          {lecture.title}
        </Heading>
        {/*<LectureKeywords data={lecture} />*/}
        <Text mt={2} noOfLines={4}>
          <GeneralMarkdown source={lecture.abstract} />
        </Text>
      </Flex>
      <Flex mt={5} justifyContent="space-between" alignItems="center">
        <LectureIncludes lecture={lecture} />
        <NextLink key={lecture.id} href={`/lecture/${lecture.id}-${lecture.slug}`} passHref>
          <Button onClick={(e) => e.stopPropagation()} h={10} px={5} py="2">
            {t('library.lecture.go_to_button')}
          </Button>
        </NextLink>
      </Flex>
    </Flex>
  );
};
